module.exports = __webpack_public_path__ + "android-chrome-192x192.43328a0e.png";